module.exports = __webpack_public_path__ + "img/special.0ef4770b.svg";